module.exports = __webpack_public_path__ + "img/angststoerungen1_640.2eb5753e.webp";